import styled from 'styled-components'
import variables from '../../styles/variables'

export const Container = styled.div`
  width: 100%;
  padding: 20px;

  @media ${variables.media.lg} {
    padding: 0;
    display: flex;
    flex-direction: row;
  }
`

const tocWidth = 280

export const TocContainer = styled.nav`
  @media ${variables.media.lg} {
    padding: 0px 25px 30px 25px;
    width: ${tocWidth}px;
    overflow-y: auto;
    height: 100%;
    position: fixed;
    top: 0;
    background: #fcfcfc;
    border-right: 1px solid #e9e9e9;
  }
`

export const Content = styled.div`
  @media ${variables.media.lg} {
    margin-left: ${tocWidth}px;
    width: calc(100% - ${tocWidth}px);
  }
`
